import React, { useState, useEffect } from "react"
import "./style.scss"
import { getDownloadAppData } from "../../data"
import config from "../../config"

function DownloadApp() {
  const [DLAppData, setDLAppData] = useState(null)
  useEffect(() => {
    document.title = "Download the app"
    loadCMSDownloadAppData()
  }, [])

  // Call loadCMSDownloadAppData function to get Download monument app form Data.
  const loadCMSDownloadAppData = async () => {
    const downloadAppFormData = await getDownloadAppData()
    setDLAppData(downloadAppFormData)
  }
  const { marketingURL } = config.downloadAppConst

  return (
    <React.Fragment>
      {DLAppData &&
        (DLAppData.error ? (
          <div className="errorPage">{DLAppData.error}</div>
        ) : (
          <div className="downloadAppContainer" data-testid="Download-app">
            {/* Download App header */}
            <div className="downloadApp-header">
              <a href={marketingURL} rel="noreferrer">
                <img
                  className="monumentLogo"
                  src={DLAppData.logo.url}
                  alt="brand logo"
                />
              </a>
            </div>
            <div className="downloadApp-body">
              {/* Download App Title */}
              {DLAppData.title && (
                <div className="body-title">{DLAppData.title}</div>
              )}
              {/* Download App Summary */}
              {DLAppData.summary && (
                <div className="body-subtitle">{DLAppData.summary}</div>
              )}
              {/* Download App QR code */}
              {DLAppData.qr.url && (
                <div className="body-QR">
                  <img
                    className="monumentLogo QRImage"
                    src={DLAppData.qr.url}
                    alt="QR logo"
                  />
                </div>
              )}
              {DLAppData.qrSummary && (
                <div className="store-title">{DLAppData.qrSummary}</div>
              )}
              {/* Show link to download from appstore and playstore*/}
              <div className="store-links">
                {DLAppData.appStore && DLAppData.appStore.url && (
                  <span>
                    <a
                      href={config.downloadAppConst.appStoreURL}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="appstore"
                        src={DLAppData.appStore.url}
                        alt="appstore logo"
                      />
                    </a>
                  </span>
                )}
                {DLAppData.playStore && DLAppData.playStore.url && (
                  <span>
                    <a
                      href={config.downloadAppConst.playStoreURL}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="appstore"
                        src={DLAppData.playStore.url}
                        alt="playstore logo"
                      />
                    </a>
                  </span>
                )}
              </div>
            </div>
          </div>
        ))}
    </React.Fragment>
  )
}
export default DownloadApp
